import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/CloseRounded';
import LeftArrow from '@material-ui/icons/ChevronLeftRounded';
import Button from '../Button';

interface IProps {
  hideCloseButton?: boolean;
  id?: string;
  open: boolean;
  onClose: any;
  title?: string;
  text?: string;
  actions?: JSX.Element | JSX.Element[];
  className?: string;
  children?: JSX.Element;
  wideButton?: boolean;
  tooltip?: JSX.Element | JSX.Element[];
  large?: boolean;
  goBackText?: string;
}

const Modal = (props: IProps) => {
  const {
    hideCloseButton,
    id,
    open,
    onClose,
    title,
    actions,
    text,
    children,
    className,
    wideButton,
    goBackText,
    tooltip,
    large
  } = props;

  const variant = wideButton ? 'modal-actions--wide-button' : '';

  return (
    <Dialog
      id={id}
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={className}
      classes={{
        paper: `${className}-paper modal-paper ${large ? 'large' : ''}`,
        root: 'dialog-modal'
      }}
    >
      <DialogTitle
        className={`${className}-title modal-title override`}
        disableTypography={true}
        id="alert-dialog-title"
      >
        {!!goBackText && (
          <Button
            aria-label="Close"
            color="primary"
            className="modal-title__goBack override"
            onClick={onClose}
          >
            <LeftArrow /> {goBackText}
          </Button>
        )}

        <div className="modal-title__inner-container override">
          <h3 className="modal-title__text">{title}</h3>
          {tooltip}
        </div>

        {!hideCloseButton && (
          <IconButton aria-label="Close" className="modal-title__close override" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>

      {(Boolean(text) || Boolean(children)) && (
        <DialogContent className={`${className}-content modal-content override`}>
          {Boolean(text) && (
            <DialogContentText
              className="modal-content__description override"
              id="alert-dialog-description"
            >
              {text}
            </DialogContentText>
          )}
          {children}
        </DialogContent>
      )}

      {Boolean(actions) && (
        <DialogActions className={`${className}-actions modal-actions override ${variant}`}>
          {actions}
        </DialogActions>
      )}
    </Dialog>
  );
};

export { Modal };
